import { render, staticRenderFns } from "./FundaBNPL.vue?vue&type=template&id=fa979bba&scoped=true&"
import script from "./FundaBNPL.vue?vue&type=script&lang=js&"
export * from "./FundaBNPL.vue?vue&type=script&lang=js&"
import style0 from "./FundaBNPL.vue?vue&type=style&index=0&id=fa979bba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa979bba",
  null
  
)

export default component.exports